/**
 * Created by pajicv on 10/1/18.
 */
export const MANAGER_ROLE = 'manager';
export const WORKER_ROLE = 'worker';
export const CO_MANAGER_ROLE = 'co-manager';

export const templates = {
    TEMPLATE1: {
        learn: ['Mitbewerberanalyse', 'Trends', 'Kundenbefragung', 'IST Customer Journey', 'Touchpoints'],
        define: ['Personas', 'Beduerfnisse', 'Use Cases', 'SOLL Customer Journey', 'Anforderungskonzept', 'Inhaltskonzept'],
        build: ['Workflows/Interaktionen', 'Wireframes', 'User Testing WF', 'Design/Layout', 'User Testing Design'],
        test: ['Prototyp', 'User Testing Prototyp', 'Ergebnisse']
    }
};


// WEBPACK FOOTER //
// ./src/utils/constants.js